__turbopack_context__.v({
  "list": "SearchLoadingState-module__U2yx4q__list" + " " + __turbopack_context__.i(524956)["list"],
  "skeletonChevron": "SearchLoadingState-module__U2yx4q__skeletonChevron",
  "skeletonContent": "SearchLoadingState-module__U2yx4q__skeletonContent",
  "skeletonItem": "SearchLoadingState-module__U2yx4q__skeletonItem",
});
